var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "search-btn-span": 24,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channelTypeCode", "storeIdList"],
                    "query-labels": [
                      _vm.$t("ChannelManagement.Header.method"),
                      _vm.$t("ChannelManagement.Header.shop"),
                    ],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.type"),
                          prop: "onlineStoreTypeCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.type"
                            ),
                            "lov-code": "SCHL.SHOP_TYPE",
                          },
                          model: {
                            value: _vm.queryParams.onlineStoreTypeCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "onlineStoreTypeCode",
                                $$v
                              )
                            },
                            expression: "queryParams.onlineStoreTypeCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.Parent"),
                          prop: "orgName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.Parent"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orgName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orgName", $$v)
                            },
                            expression: "queryParams.orgName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.Name"),
                          prop: "channelWarehouseName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.Name"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.channelWarehouseName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "channelWarehouseName",
                                $$v
                              )
                            },
                            expression: "queryParams.channelWarehouseName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.Store"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.Store"
                            ),
                            "option-list": _vm.STATUS_ENABLED_TRUE,
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "seniorForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "ChannelManagement.Header.Authorization"
                          ),
                          prop: "authStatus",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.CHANNEL_ONLINE_CREDIT_STATUS,
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.Authorization"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.authStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "authStatus", $$v)
                            },
                            expression: "queryParams.authStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.taxCode"),
                          prop: "taxCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.taxCode"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.taxCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "taxCode", $$v)
                            },
                            expression: "queryParams.taxCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.accountCode"),
                          prop: "accountCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.accountCode"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.accountCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "accountCode", $$v)
                            },
                            expression: "queryParams.accountCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.currency"),
                          prop: "currency",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.currency"
                            ),
                            "option-list": _vm.CURRENCY_LIST,
                          },
                          model: {
                            value: _vm.queryParams.currency,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "currency", $$v)
                            },
                            expression: "queryParams.currency",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "ChannelManagement.Header.typeOfFreight"
                          ),
                          prop: "autoTableStatus",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "lov-code": "FREIGHT_TYPE",
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.typeOfFreight"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.autoTableStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "autoTableStatus", $$v)
                            },
                            expression: "queryParams.autoTableStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "ChannelManagement.Header.shippingCostAutoStatus"
                          ),
                          prop: "shippingCostAutoStatus",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_YES_NUM,
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.shippingCostAutoStatus"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.shippingCostAutoStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "shippingCostAutoStatus",
                                $$v
                              )
                            },
                            expression: "queryParams.shippingCostAutoStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ChannelManagement.Header.project"),
                          prop: "project",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ChannelManagement.Header.project"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryParams.project,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "project", $$v)
                            },
                            expression: "queryParams.project",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessChannelOnlineList_Delete",
                            arg: "BusinessChannelOnlineList_Delete",
                          },
                        ],
                        staticClass: "delete-btn",
                        attrs: {
                          type: "primary",
                          disabled: tableOperationProp.notSelected,
                        },
                        on: { click: _vm.onDeleteSelected },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessChannelOnlineList_Add",
                            arg: "BusinessChannelOnlineList_Add",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("ChannelManagement.Header.New")))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "authStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row.authStatus === 2
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.CHANNEL_ONLINE_CREDIT_STATUS.bjGet(
                                                      scope.row.authStatus
                                                    )
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "status"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.status
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_TRUE.bjGet(
                                                    scope.row.status
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "autoTableStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.autoTableStatus
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_TRUE.bjGet(
                                                    scope.row.autoTableStatus
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "shippingCostAutoStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row
                                                .shippingCostAutoStatus
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_TRUE.bjGet(
                                                    scope.row
                                                      .shippingCostAutoStatus
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "channelWarehouseStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row
                                                .channelWarehouseStatus
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_TRUE.bjGet(
                                                    scope.row
                                                      .channelWarehouseStatus
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : [
                                          "autoDownloadGoods",
                                          "autoPullOrder",
                                          "autoSyncInventory",
                                        ].includes(col.prop)
                                      ? [
                                          _c("i", {
                                            class: scope.row[col.prop]
                                              ? "el-icon-check"
                                              : "",
                                          }),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessChannelOnlineList_Edit",
                                            arg: "BusinessChannelOnlineList_Edit",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        on: {
                                          command: function ($event) {
                                            return _vm.command(
                                              $event,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.common.operate"
                                                )
                                              )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  command: "distribution",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ChannelManagement.Main.distribution"
                                                    )
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            props.row.status
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessChannelOnlineList_Status",
                                                        arg: "BusinessChannelOnlineList_Status",
                                                      },
                                                    ],
                                                    attrs: { command: "stop" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("disableText")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !props.row.status
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessChannelOnlineList_Status",
                                                        arg: "BusinessChannelOnlineList_Status",
                                                      },
                                                    ],
                                                    attrs: { command: "start" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("enableText")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:BusinessChannelOnlineList_Delete",
                                                    arg: "BusinessChannelOnlineList_Delete",
                                                  },
                                                ],
                                                attrs: {
                                                  command: "delete",
                                                  disabled: props.row.status,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("delText")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              { attrs: { command: "inquiry" } },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ChannelManagement.Main.productPrice"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", {
        ref: "DataForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
      _c("AuthorizeForm", {
        ref: "AuthorizeForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.title,
            visible: _vm.setDialogVisible,
            "before-close": _vm.handleClose,
            width: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.setDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "setForm",
              staticClass: "bj-label-colon",
              attrs: {
                inline: false,
                model: _vm.setForm,
                rules: _vm.setRules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("ChannelManagement.Main.name"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      disabled: "",
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.setForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "name", $$v)
                      },
                      expression: "setForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("ChannelManagement.Main.shipment"),
                    prop: "autoConfirmDay",
                  },
                },
                [
                  _c("BjInputNumber", {
                    attrs: { "not-auto-zero": "" },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("ChannelManagement.Main.Day")) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.setForm.autoConfirmDay,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "autoConfirmDay", $$v)
                      },
                      expression: "setForm.autoConfirmDay",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ChannelManagement.Main.products") } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.setForm.autoDownloadGoods,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "autoDownloadGoods", $$v)
                      },
                      expression: "setForm.autoDownloadGoods",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("ChannelManagement.Main.inventory") },
                },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.setForm.autoSyncInventory,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "autoSyncInventory", $$v)
                      },
                      expression: "setForm.autoSyncInventory",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSetConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }